import useIsomorphicLayoutEffect from '../../common/hook/useIsomorphicLayoutEffect';

export default function useSetBodyColor(bgColor?: string) {
  useIsomorphicLayoutEffect(() => {
    if (!bgColor) return;

    document.body.style.backgroundColor = bgColor;
    return () => {
      document.body.style.removeProperty('background-color');
    };
  }, [bgColor]);
}
